import { createMutationGroup } from "../../core/api/mutations";
import { components, ContractTypeId, OfficeId, ServiceCodeId } from "../../shared/schema/schema";

export type ServiceCodeIssuesOverride = components["schemas"]["ServiceCodeIssuesSetting"];

// Request body for an upsert: the override without the contract type (it comes from the path).
export type ServiceCodeIssuesOverrideBody = Omit<ServiceCodeIssuesOverride, "contractTypeId">;

export default createMutationGroup(({ api, createMutation }) => ({
  upsertServiceCodeOverride: (contractTypeId: ContractTypeId) =>
    createMutation({
      mutationFn: (body: ServiceCodeIssuesOverrideBody) =>
        api.post("/agencies/:agencyId/contractType/:contractTypeId/service_code_issues_settings", {
          path: { contractTypeId },
          body,
        }),
    }),

  deleteServiceCodeOverride: (contractTypeId: ContractTypeId) =>
    createMutation({
      mutationFn: (vars: { officeId: OfficeId; serviceCodeId: ServiceCodeId }) =>
        api.delete(
          "/agencies/:agencyId/contractType/:contractTypeId/offices/:officeId/service_code_issues_settings/:serviceCodeId",
          {
            path: {
              contractTypeId,
              officeId: vars.officeId,
              serviceCodeId: vars.serviceCodeId,
            },
          }
        ),
    }),
}));
